import * as _ from 'lodash';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers';
import {
  type AbsoluteCallPath,
  type EnumReachable,
  EnumReachableAssumed,
} from '../../../../../shared/reachability/types';

import { buildCallPath } from './utils';

import styles from './Reachability.module.less';

function padDepth(depth: number): ReactNode {
  return new Array(depth * 2).fill(<>&nbsp;</>);
}

type Props = {
  reachable?: EnumReachable
  callPaths?: AbsoluteCallPath[];
};

/**
 * Visualize the reachable call paths for a given project.
 */
const Visualization: VoidFunctionComponent<Props> = ({ reachable, callPaths }) => {
  if (!callPaths?.length) {
    return (
      <div className={styles.visualization}>No call paths available.</div>
    );
  }

  // group call paths by unique vulnerable FQSNs
  const callPathsByFunction = _.groupBy(callPaths, (callPath) => {
    return _.last(buildCallPath(callPath.relative));
  });

  const callPathsByFunctionsEntries = Object.entries(callPathsByFunction);
  const count = callPathsByFunctionsEntries.length;
  return (
    <div className={styles.visualization}>
      <div className={styles.visualizationHeader}>{count} {plural(count, 'function')} identified</div>
      <div className={styles.visualizationBody}>
        {callPathsByFunctionsEntries.map(([fqsn, paths], index) => {
          return (
            <>
              <hr />
              <div className={styles.visualizationFQSN}>{index + 1}. {fqsn}</div>
              {reachable !== EnumReachableAssumed && paths.map((path) => {
                return (
                  <>
                    <div className={styles.visualizationCallPathRoot}>
                      {path.root.filePath} ({path.root.lineStart}:{path.root.lineEnd})
                    </div>
                    {buildCallPath(path.relative).map((callPath, callPathIndex) => {
                      const padding = padDepth(callPathIndex);
                      return (
                        <div>{padding}&#9584; {callPath}</div>
                      );
                    })}
                  </>
                );
              })}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Visualization;
